import api from '@/services/api/api';
import { useQuery } from '@tanstack/react-query';

const useGetOrganizationCustomer = () => {
  return useQuery({
    queryKey: ['getOrganizationCustomer'],
    queryFn: () => api.organization.getOrganizationCustomer()
  });
};

export default useGetOrganizationCustomer;
